export { default } from './ManualOperadors';
